import React, { useState } from "react";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { FaEdit } from "react-icons/fa";
import ClassificationAddAndEditModal from "./modal/ClassificationAddEditModal";
import { useClassificationListData } from "./hooks/useClassification";

const classificationColums = (handleEditSubscriberType: (row: any) => void) => [
  {
    name: "Classification",
    selector: (row: { Classification: number | string }) =>
      row.Classification,
    width: "90%",
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          onClick={() => handleEditSubscriberType(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      </div>
    ),
  },
];

const Classifications: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>('')
  const [paginationStates, setPaginationStates] = useState<any>({
    limit: 10,
    page: 1,
    search: null,
  });
  const [rowData, setRowData] = useState(null)
    const [isDownloading,setIsDownloading]=useState(false)
  const { data } = useClassificationListData({
    enable: true, params: {
      limit: paginationStates.limit,
      page: paginationStates.page,
      search: paginationStates.search,
    }
  });
  const handleExcel = async () => {
  try {
    setIsDownloading(true);
    const appToken = localStorage.getItem("Apptoken") || "";

    const search = paginationStates?.search || "";
        

    const params = new URLSearchParams();

    // Append only if the value exists

  
    if (search) params.append("search", search);

    const response = await fetch(
      `https://tspc-development.truesales.in/admin/api/getClassificationListExcel?${params.toString()}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          apptoken: appToken,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download Excel file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "Customer Tag List.xlsx"; // custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading Excel file:", error);
  }
    finally{
     setIsDownloading(false);
  }
};

  const handleEditSubscriberType = (row: any) => {
    setRowData(row)
    setCheckAddEditStatus('Edit')
    setIsModalOpen(true)
  }

  const toggleModal = () => {
    setCheckAddEditStatus('Add')
    setIsModalOpen(true);
  }

  const handlePagination = (pageNo: number) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };


  return (
    <div className="p-4">
      <PageHeader
        title="Classifications"
        buttons={[
          {
            label: "+Add Classifications",
            onClick: toggleModal,
            color: "#2e8dd3",
          },{
           label: isDownloading ? "Downloading..." : "Excel",
            onClick:handleExcel,
            color: "#43B9B2",
            disable:isDownloading
          }
        ]}
      />
      <BasicDataTable
        paginationTotalRows={data?.data?.data?.Pagination?.TotalClassifications || 0}
        onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page)
        }}
        handleSearch={(val: any) => { handleSearch(val) }}
        Title="Classifications"
        columns={classificationColums(handleEditSubscriberType)}
        data={data?.data?.data?.Classifications || []}
      />

      <ClassificationAddAndEditModal rowData={rowData} setCheckAddEditStatus={setCheckAddEditStatus}  checkAddEditStatus={checkAddEditStatus} setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} title={checkAddEditStatus == 'Add' ? 'Add Classification' : 'Edit Classification'} />
    </div>
  );
};
export default Classifications;
